import { rootRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { FeedbackPage } from ".";

const index = createRoute({
  path: "feedback",
  getParentRoute: () => rootRoute,
  validateSearch: (
    search: Record<string, unknown>,
  ): { feedbackSentiment: number; orderId: number } => {
    return {
      feedbackSentiment: Number(search.feedbackSentiment),
      orderId: Number(search.orderId || "0"),
    };
  },
  component: FeedbackPage,
});

export const feedbackRoutes = index;
